import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import smoothscroll from 'smoothscroll-polyfill';

import { AboutStudySlice } from './slices/AboutStudySlice';
import { BenefitsSlice } from './slices/BenefitsSlice';
import { CtaSlice } from './slices/CtaSlice';
import { HeroSlice } from './slices/HeroSlice';
import { MapSlice } from './slices/MapSlice';
import { OverviewSlice } from './slices/OverviewSlice';
import { WhatYouGetSlice } from './slices/WhatYouGetSlice';

import { FooterOnlyLayout } from '@/layouts/FooterOnly';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const components = {
  hero_section: HeroSlice,
  map_slice: MapSlice,
  cta_section: CtaSlice,
  distributed_work_slice: OverviewSlice,
  about_study: AboutStudySlice,
  overview_with_image: BenefitsSlice,
  what_you_get_slice: WhatYouGetSlice,
};

export function GlobalWorkforceReportPage(document) {
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <>
      <DocumentHead document={document} />
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-bossa.css')} />
      </Head>
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </>
  );
}
GlobalWorkforceReportPage.Layout = FooterOnlyLayout;
